import { render, staticRenderFns } from "./StaffListPage.vue?vue&type=template&id=527eef98&"
import script from "./StaffListPage.vue?vue&type=script&lang=ts&"
export * from "./StaffListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports